import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { EmailThreadsListQuery } from '@rossum/api-client/emailThreads';
import { GridFilterItem } from '@rossum/ui/x-data-grid-pro';
import { useApiClient } from '../../../../lib/apiClient';
import { encodeEmailsFiltering } from '../encodeEmailsFiltering';
import { transformEmailThreads } from '../helpers';

export const QUERY_KEY_EMAIL_THREADS = 'email-threads';

export const useFetchEmailThreads = (
  query: EmailThreadsListQuery,
  filtering: GridFilterItem[],
  ordering: string
) => {
  const { queue } = query;
  const api = useApiClient();

  const targetQuery = {
    ...query,
    ...encodeEmailsFiltering(filtering),
    ...(ordering ? { ordering } : {}),
  };

  return useQuery({
    queryKey: [QUERY_KEY_EMAIL_THREADS, targetQuery] as const,

    queryFn: () => {
      return api.request(endpoints.emailThreads.list(targetQuery));
    },
    enabled: !!queue,
    select: emailThreads => {
      return {
        pagination: emailThreads.pagination,
        results: transformEmailThreads(emailThreads.results ?? []),
      };
    },
  });
};
